export const endpoints = {
  marketplace: {
    home: "multi-tienda/home",
    products: "multi-tienda/products",
    brandProducts: (clientId: number): string =>
      `multi-tienda/brands/${encodeURIComponent(String(clientId))}/products`,
    search: (value: string): string => `multi-tienda/products/search/${encodeURIComponent(value)}`
  }
} as const;
